import PropTypes from 'prop-types';

import { isEmptyConvertProjection } from '#/modules/imsMgmt/settings/mtr/helper/unitAggregateSerialize';

function displayOrDash(value) {
  if (value === null || value === undefined || value === '') {
    return '—';
  }
  return value;
}

function resolveConvertRow(convert) {
  if (isEmptyConvertProjection(convert)) {
    return null;
  }
  if (Array.isArray(convert)) {
    return convert.find((row) => !isEmptyConvertProjection(row)) ?? null;
  }
  return convert;
}

/**
 * Detail 唯讀：unit.base／unit.convert（單一 object；相對基本 convert_rate）。
 */
const MtrUnitsReadonlySection = ({ detail, enabled = true }) => {
  if (!enabled) {
    return null;
  }

  const unit = detail?.unit;
  const base = unit?.base ?? null;
  const convert = resolveConvertRow(unit?.convert);
  const baseName = base?.name || '基本單位';
  const empty = !base && !convert;
  const defaultDisplayUnit = detail?.defaultDisplayUnit;
  const receiptDefaultQty = detail?.receiptDefaultQty;

  return (
    <div className="receipt-card-elevate">
      <div className="receipt-card-surface p-5">
        <h2 className="form-block__title">物料單位</h2>
        {empty ? (
          <p className="mt-2 text-sm text-muted-foreground">尚無物料單位</p>
        ) : (
          <div className="mt-3 overflow-x-auto rounded border border-slate-200">
            <table className="w-full min-w-xl text-left text-sm">
              <thead className="bg-slate-100 text-xs text-gray-600">
                <tr>
                  <th className="px-2 py-1.5 font-medium">列</th>
                  <th className="px-2 py-1.5 font-medium">名稱</th>
                  <th className="px-2 py-1.5 font-medium">相對基本</th>
                </tr>
              </thead>
              <tbody>
                {base ? (
                  <tr className="border-t border-slate-200">
                    <td className="px-2 py-1.5">
                      <span className="rounded bg-primary-100 px-1 text-xs text-primary-800">
                        基本
                      </span>
                    </td>
                    <td className="px-2 py-1.5">{displayOrDash(base.name)}</td>
                    <td className="px-2 py-1.5">1＝1</td>
                  </tr>
                ) : null}
                {convert ? (
                  <tr
                    key={convert.id || convert.name}
                    className="border-t border-slate-200"
                  >
                    <td className="px-2 py-1.5">1</td>
                    <td className="px-2 py-1.5">{displayOrDash(convert.name)}</td>
                    <td className="px-2 py-1.5 whitespace-nowrap">
                      {`＝ ${displayOrDash(convert.convertRate)} 個「${baseName}」`}
                    </td>
                  </tr>
                ) : null}
              </tbody>
            </table>
          </div>
        )}
        {!empty ? (
          <div className="mt-3 grid grid-cols-1 gap-2 sm:grid-cols-2">
            <p className="text-sm text-gray-700">
              <span className="text-xs text-gray-500">預設顯示單位：</span>
              {defaultDisplayUnit === 'CONVERT' ? '進位單位' : '基礎單位'}
            </p>
            <p className="text-sm text-gray-700">
              <span className="text-xs text-gray-500">入庫預設數量：</span>
              {receiptDefaultQty == null || receiptDefaultQty === ''
                ? '—'
                : receiptDefaultQty}
            </p>
          </div>
        ) : null}
      </div>
    </div>
  );
};

MtrUnitsReadonlySection.propTypes = {
  detail: PropTypes.object,
  enabled: PropTypes.bool,
};

export default MtrUnitsReadonlySection;
